// extracted by mini-css-extract-plugin
module.exports = {"tagline":"NextReleaseSneakPeak_tagline__xTcrC","topHeader":"NextReleaseSneakPeak_topHeader__n3PWV"};